import { render } from "./Unit2-1.vue?vue&type=template&id=20f13e2f&scoped=true"
import script from "./Unit2-1.vue?vue&type=script&lang=js"
export * from "./Unit2-1.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/Unit2-1.css?vue&type=style&index=1&id=20f13e2f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f13e2f"]])

export default __exports__